import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { auth as authApi, ApiError, type AuthUser } from '../api/client'
import { useTranslation } from '../i18n/LanguageContext'

interface VerifyEmailPageProps {
  onSuccess: (accessToken: string, user: AuthUser) => void
  onBack:    () => void
}

type State = 'verifying' | 'success' | 'error'

export default function VerifyEmailPage({ onSuccess, onBack }: VerifyEmailPageProps) {
  const [searchParams]  = useSearchParams()
  const { t }           = useTranslation()
  const a               = t.auth
  const [state, setState] = useState<State>('verifying')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) { setState('error'); return }

    authApi.verifyEmail(token)
      .then((res) => {
        onSuccess(res.accessToken, res.user)
        setState('success')
      })
      .catch((err) => {
        if (err instanceof ApiError && err.status === 400) {
          setState('error')
        } else {
          setState('error')
        }
      })
  // Run only once on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        {state === 'verifying' && (
          <>
            <span style={styles.emoji}>⏳</span>
            <h2 style={styles.title}>Verificando…</h2>
          </>
        )}
        {state === 'success' && (
          <>
            <span style={styles.emoji}>✅</span>
            <h2 style={styles.title}>{a.resetSuccess}</h2>
          </>
        )}
        {state === 'error' && (
          <>
            <span style={styles.emoji}>❌</span>
            <h2 style={styles.title}>{a.resetExpired}</h2>
            <button onClick={onBack} style={styles.btn}>{a.backToLogin}</button>
          </>
        )}
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  root: {
    minHeight:      '100vh',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    background:     '#FAF6EF',
    padding:        '24px',
  },
  card: {
    background:    '#FFFFFF',
    borderRadius:  20,
    border:        '2px solid #E8DDD0',
    padding:       '48px 40px',
    maxWidth:      420,
    width:         '100%',
    textAlign:     'center',
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    gap:           16,
    boxShadow:     '0 4px 24px rgba(0,0,0,0.07)',
  },
  emoji: { fontSize: '3rem', lineHeight: 1 },
  title: {
    fontFamily:  "'Cormorant Garamond', serif",
    fontSize:    '1.6rem',
    fontWeight:  700,
    color:       '#1B4332',
    margin:      0,
    lineHeight:  1.2,
  },
  btn: {
    marginTop:    8,
    padding:      '14px 28px',
    fontSize:     '1rem',
    fontWeight:   700,
    color:        '#FFFFFF',
    background:   'linear-gradient(135deg, #1B4332, #2D6A4F)',
    border:       'none',
    borderRadius: 12,
    cursor:       'pointer',
    minHeight:    48,
  },
}
